import { defineMessages } from 'react-intl';

export default defineMessages({
  zendeskChatCTA: {
    id: 'pages.partnerZendeskChat.zendeskChatCTA',
    defaultMessage: 'Chat with us',
  },
});
